import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { Token } from '@/domain/types/Token'
import { TxOverviewRouteItem } from '@/features/dialogs/common/types'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'
import { testIds } from '@/ui/utils/testIds'

export interface UnstakeTransactionOutcomeProps {
  outcomeTokenRouteItem: TxOverviewRouteItem
  rewardToken: Token
  isExiting: boolean
  earnedRewards: NormalizedNumber
  farmName: string
}

export function UnstakeTransactionOutcome({
  outcomeTokenRouteItem,
  rewardToken,
  isExiting,
  earnedRewards,
  farmName,
}: UnstakeTransactionOutcomeProps) {
  const exitContent = (() => {
    if (isExiting) {
      return (
        <div className="flex items-center gap-2">
          <TransactionOverview.TokenAmountOutcome
            token={outcomeTokenRouteItem.token}
            amount={outcomeTokenRouteItem.value}
            postFix={`Withdrawn from ${farmName}`}
            amountDataTestId={testIds.farmDetails.unstakeDialog.transactionOverview.outcome}
          />
          <div className="text-secondary">+</div>
          <TransactionOverview.TokenAmountOutcome
            token={rewardToken}
            amount={earnedRewards}
            postFix="Claimed"
            amountDataTestId={testIds.farmDetails.unstakeDialog.transactionOverview.rewardOutcome}
            usdValueDataTestId={testIds.farmDetails.unstakeDialog.transactionOverview.rewardOutcomeUsd}
            showUsdValue
          />
        </div>
      )
    }

    return (
      <TransactionOverview.TokenAmountOutcome
        token={outcomeTokenRouteItem.token}
        amount={outcomeTokenRouteItem.value}
        postFix={`Withdrawn from ${farmName}`}
        amountDataTestId={testIds.farmDetails.unstakeDialog.transactionOverview.outcome}
      />
    )
  })()

  return exitContent
}
